import React from 'react';
import { Button } from 'wbm-inputs';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

type BreadProps = {
    url: string,
    text: string
  }
  
export const BackBreadcrumb = ({ ...props }: BreadProps) => {

    return (
        <div className="bread-item">            
            <Button className="btn-link medium">               
                <a className="bread-link" href={props.url}>    
                    <KeyboardBackspaceIcon className="bread-back" />
                    {props.text}
                </a>
            </Button>
        </div>
    );
}
